import React, { useEffect, useState } from 'react';
import { Star, X } from 'lucide-react';
import { trackEvent } from '../lib/ga';

const PLACE_ID = 'ChIJn2-dAO_1UYYRywVs-W5HN4U';
const WRITE_REVIEW_URL = `https://search.google.com/local/writereview?placeid=${PLACE_ID}`;
const DISMISS_KEY = 'review_nudge_dismissed_at';
const DISMISS_DAYS = 14;

export const ReviewNudge = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = localStorage.getItem(DISMISS_KEY);
    if (dismissedAt) {
      const days = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (days < DISMISS_DAYS) return;
    }
    const t = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[60] max-w-[320px] w-[calc(100%-2rem)] sm:w-80 animate-in slide-in-from-bottom-4 fade-in duration-500"
      data-testid="review-nudge"
    >
      <div className="relative bg-white rounded-2xl shadow-2xl border border-pink-100 p-4 pr-8">
        <button
          onClick={dismiss}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 transition-colors"
          aria-label="Dismiss"
          data-testid="review-nudge-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-2 mb-1">
          <img
            src="https://www.gstatic.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
            alt="Google"
            className="h-4"
          />
          <div className="flex">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
            ))}
          </div>
        </div>
        <p className="text-sm text-gray-800 font-semibold leading-snug mb-3">
          Loved your visit? Leave us a quick Google review — it means the world to our small shop! 🍦
        </p>
        <a
          href={WRITE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => { trackEvent('review_nudge_click', { source: 'home' }); dismiss(); }}
          className="inline-flex items-center justify-center gap-2 w-full px-4 py-2 rounded-full text-white text-sm font-bold transition-opacity hover:opacity-90"
          style={{ background: 'linear-gradient(135deg, #E91E8C 0%, #C4197A 100%)' }}
          data-testid="review-nudge-cta"
        >
          <Star className="w-4 h-4" /> Leave a Review
        </a>
      </div>
    </div>
  );
};

export default ReviewNudge;
